import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import Modal from '../modal-dialog/Modal';

import './SignInDialog.scss';

export type SignInDialogTranslation = {
	title: string;
	content: string;
	cancel: string;
	signIn: string;
	closeAriaLabel: string;
	dialogAriaLabel: string;
};

export type SignInDialogProps = {
	t: SignInDialogTranslation;
	closeButton?: boolean;
};

export type SignInDialogRef = {
	open: (signInCallback: () => void | Promise<void> | null) => void;
};

const SignInDialog = forwardRef<SignInDialogRef, SignInDialogProps>(
	(props, ref) => {
		const [isSignInDialogOpen, setSignInDialogOpen] = useState<boolean>(false);
		const signInCallbackRef = useRef<() => void | Promise<void>>(null);
		const closeButton =
			props.closeButton !== undefined ? props.closeButton : true;

		useImperativeHandle(ref, () => {
			return {
				open: (signInCallback) => {
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					signInCallbackRef.current = signInCallback;
					setSignInDialogOpen(true);
				},
			};
		});

		const closeSignInDialog = () => {
			if (!closeButton) return;
			setSignInDialogOpen(false);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			signInCallbackRef.current = null;
		};

		const handleSignIn = () => {
			signInCallbackRef.current?.();
			closeSignInDialog();
		};

		return (
			<>
				{isSignInDialogOpen && (
					<Modal
						ariaLabelDialog={props.t.dialogAriaLabel}
						closeCallback={closeSignInDialog}
						ariaLabelCloseButton={props.t.closeAriaLabel}
						closeButton={closeButton}
					>
						<div className="blk-ac-modal-container blk-ac-sign-in-dialog">
							<h2 className="blk-ac-heading-s blk-ac-sign-in-dialog-title">
								{props.t.title}
							</h2>

							<div className="blk-ac-body-m blk-ac-sign-in-dialog-content">
								{props.t.content}
							</div>

							<div className="blk-ac-sign-in-dialog-footer">
								{closeButton && (
									<button
										className="blk-ac-secondary-button"
										onClick={closeSignInDialog}
									>
										{props.t.cancel}
									</button>
								)}
								<button
									className="blk-ac-primary-button"
									onClick={handleSignIn}
								>
									{props.t.signIn}
								</button>
							</div>
						</div>
					</Modal>
				)}
			</>
		);
	}
);

SignInDialog.displayName = 'SignInDialog';

export default SignInDialog;
